<template>
    <div class="session-closed-alert-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-pdv-small modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" @click="onClose" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>

                <div class="main-content">
                    <img src="/images/iconos/clock-white.svg" alt="">

                    <h3>TU SESIÓN SE CERRÓ <br>POR INACTIVIDAD</h3>

                    <a href="#" @click.prevent="onContinue" class="btn-pdv-primary ">VOLVER AL INICIO</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        mounted() {
            // Escuchar cuando el modal se cierra para limpiar el backdrop
            const modal = document.querySelector('.session-closed-alert-modal');
            if (modal && window.$ && typeof window.$.fn.modal === 'function') {
                window.$(modal).on('hidden.bs.modal', () => {
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());
                    document.body.classList.remove('modal-open');
                });
                
                // Escuchar cuando el modal se abre para debug
                window.$(modal).on('shown.bs.modal', () => {
                });
            }
            
            // Prevenir cierre del modal con ESC
            this.handleKeydown = (e) => {
                if (e.key === 'Escape') {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            };
            document.addEventListener('keydown', this.handleKeydown);
            
            // Prevenir cierre del modal haciendo clic fuera
            this.handleClick = (e) => {
                if (e.target.classList.contains('modal-backdrop')) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            };
            document.addEventListener('click', this.handleClick);
        },
        beforeDestroy() {
            // Limpiar event listeners cuando el componente se destruye
            const modal = document.querySelector('.session-closed-alert-modal');
            if (modal && window.$ && typeof window.$.fn.modal === 'function') {
                window.$(modal).off('hidden.bs.modal');
                window.$(modal).off('shown.bs.modal');
            }
            
            // Remover event listeners del documento
            document.removeEventListener('keydown', this.handleKeydown);
            document.removeEventListener('click', this.handleClick);
        },
        methods : {
            onClose(){
                this.closeModalAndRedirect();
            },
            onContinue(){
                this.closeModalAndRedirect();
            },
            closeModalAndRedirect(){
                // Cerrar el modal usando el helper correcto
                const helper = document.getElementById('helperSessionClosedModal');
                if (helper) {
                    helper.click();
                } else {
                    console.error('❌ Helper no encontrado');
                    // Fallback: cerrar modal directamente
                    const modal = document.querySelector('.session-closed-alert-modal');
                    if (modal && window.$ && typeof window.$.fn.modal === 'function') {
                        window.$(modal).modal('hide');
                    }
                }
                
                // Esperar un momento para que el modal se cierre completamente
                setTimeout(() => {
                    // Eliminar manualmente el backdrop si existe
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());
                    document.body.classList.remove('modal-open');
                    
                    // Limpiar el localStorage
                    localStorage.clear();
                    
                    // Emitir evento para limpiar completamente el timer
                    this.$root.$emit('clear-inactivity-timer');
                    
                    // Redirigir al inicio
                    this.$router.push('/');
                }, 100);
            }
        }
    }
</script>

<style scoped lang="scss">
    .session-closed-alert-modal {
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv-small {
            max-width: 481px;
            .modal-content{
                background: #313541;
                padding: 64px 60px;
                border-radius: 1px;
                box-shadow: 0 0 12px 3px #00000038;
                min-height: 381px;
                
                button.close{
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    opacity: 1;
                    span{
                        font-size: 30px;
                        color: #fff;
                    }
                }
                .main-content{
                    text-align: center;
                    img{
                        width: 65px;
                        margin-bottom: 20px;
                    }
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        margin-bottom: 28px;
                        color: #fff;
                        @include alternative-bold;
                    }
                    .btn-pdv-primary{
                        padding: 14px 40px;
                    }
                }
            }

        }
    }

</style>